export class ContentAuditPost {
    userId: number;
    episodeShortName: string;
}